const fileDownloadErrorStatus = {
  loading: false,
  finished: true,
  responseCode: 404,
  failed: true,
  generalErrors: [
    { message: 'Pri sťahovaní dokumentu nastal neočakávaný problém (neexistujúci súbor).' }],
  fieldErrors: [],
};

export default fileDownloadErrorStatus;
